module.exports = __webpack_public_path__ + "img/5.4bd17b27.png";